<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户白名单</span>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(v,i) in formData" :key="i">
            <el-form-item label="用户ID">
              <el-input v-model="formData[i]" style="width: 150px;" placeholder="用户ID" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:userWhite:del']" type="danger" @click="del(formData[i])">删除</el-button>
            </el-form-item>
          </el-row>
          <el-button v-permisaction="['config:userWhite:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:userWhite:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { addUserWhite, delUserWhite, getUserWhiteList } from '@/api/user/user_info'

export default {
  name: 'UserWhite',
  data() {
    return {
      total: 0,
      options: [],
      rewardType: [],
      formData: [

      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = this.formData.join(',')
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      addUserWhite({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getUserWhiteList().then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push(0)
    },
    del(uid) {
      delUserWhite({ id: uid }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
